import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { CreateGroupRequest } from '../api/group/creategroup/creategrouprequest';
import { CreateGroupResponse, CreateGroupResponseDtoImpl } from '../api/group/creategroup/creategroupresponse';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { Strings } from '../../utils/resources/strings';
import { SixdeeCRBTAPIProcessor } from './sixdeecrbtapiprocessor';

export class CreateGroupAPIProcessorImpl extends SixdeeCRBTAPIProcessor<CreateGroupRequest, CreateGroupResponse>
{
    execute(request: CreateGroupRequest): void {
        super.execute(request);
    }

    onSuccess(responseMapper: ResponseMapper): void 
    {
        super.onSuccess(responseMapper);
        try 
        {
            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS)
             {
                let response = new CreateGroupResponseDtoImpl(APIFeatures.CREATE_GROUP, "Create Group Success");

                this.getAPISuccess(response);
            }
        }
        catch (e)
        {
            this.getAPIFailure(new CreateGroupResponseDtoImpl(APIFeatures.CREATE_GROUP, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
        super.onFailure(responseMapper);
     
            this.getAPIFailure(new CreateGroupResponseDtoImpl(APIFeatures.CREATE_GROUP, responseMapper.getStatusMsg()));
        
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/creategroupapiprocessor.tsx